import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SoundService} from './sound.service';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [],
    providers: [SoundService]
})

export class SoundModule {

}



// WEBPACK FOOTER //
// ./src/app/shared/sound/sound.module.ts